import React from "react";
import Menu from "../../components/Menu";
import More from '../../assets/img/mais.svg'
import Back from '../../assets/img/de-volta.svg'

import { Link } from 'react-router-dom'
import ListCardAgreements from "../../components/ListCardAgreements";
import AgreementsBlack from '../../assets/img/plano-de-saude-black.svg'
function Agreements() {
  const [search, setSearch] = React.useState("")
  const screenTela =
    <div className='screenContainer' style={{ paddingRight: '0px' }}>
      <div className="row row-container">
        <h1 className="col-6 col-sm-6 col-lg-8 name-screen"> <img style={{ width: '40px' }} alt="svg" src={AgreementsBlack} /> <span className="name-screen-title" >Convênios</span> </h1>
        <div className="col-6 col-sm-6 col-lg-4 name-search">
          <input value={search} onChange={(value) => {
            setSearch(value.target.value)
          }} type="text" placeholder="Pesquisar Convênio" className="form-control input-pesquisa" />
        </div>
          <ListCardAgreements search={search} />
      </div>
      <Link to="/dashboard">
        <div className="button-back-list">
          <img alt="mais" src={Back} />
        </div>
      </Link>
      <Link to="add">
        <div className="button-add">
          <img alt="mais" src={More} />
        </div>
      </Link>

    </div>

  return (
    <Menu screen={screenTela} />
  )
}

export default Agreements;